import { Route, Routes } from 'react-router';

import TrainerDetail from 'src/refactor_page/trainer';

const TrainerView = () => {
  return (
    <Routes>
      <Route path=":id" element={<TrainerDetail />} />
    </Routes>
  );
};

export default TrainerView;
